import { RealEstateGeoCoordinates } from '../../../../@types/real-estate-api-types'
import { GeoCoordinates } from '../../../../@types/types'

export const geoCoordinatesToApp = (
  geo: RealEstateGeoCoordinates | undefined
): { geoCoordinates: GeoCoordinates } | undefined => {
  if (geo) {
    return {
      geoCoordinates: {
        latitude: geo.latitude,
        longitude: geo.longitude,
        lambertEuCoordinatesX: geo.lambertEuCoordinatesX ?? 0,
        lambertEuCoordinatesY: geo.lambertEuCoordinatesY ?? 0,
      },
    }
  } else {
    return undefined
  }
}
